import { Constants } from '@salesforce/scv-connector-base';
import { HangupResult } from '@salesforce/scv-connector-base';
import { PhoneCallGenerator } from '@main/generators/phone-call.generator';

export class HangupResultGenerator {
  static generate(
    callId: string,
    callType: Constants.CALL_TYPE,
    phoneNumber: string,
  ): HangupResult {
    const phoneCall = PhoneCallGenerator.generate(
      callId,
      callType,
      phoneNumber,
    );

    phoneCall.state = Constants.CALL_STATE.ENDED;

    return new HangupResult({
      calls: phoneCall,
    });
  }
}
